"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserLastUsedPickupPoint = void 0;
class GetUserLastUsedPickupPoint {
    constructor(PickupPointsService) {
        this.PickupPointsService = PickupPointsService;
    }
    execute(request) {
        return this.PickupPointsService.getUserLastUsedPickupPoint(request);
    }
}
exports.GetUserLastUsedPickupPoint = GetUserLastUsedPickupPoint;
